import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageSelectorComponent } from '../../language-selector/language-selector.component';

export interface CampaignBannerVM {
  name: string;
  imageUrl: string;
}

@Component({
    selector: 'don-campaign-selected-banner',
    imports: [CommonModule, LanguageSelectorComponent],
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignSelectedBannerComponent {
  @Input({ required: true }) campaign: CampaignBannerVM | null = null;

  /** Placeholder si viene vacío */
  fallback = '/assets/Image/Story/banner.webp';

  constructor(public translate: TranslateService) {}
  changeLanguage(lang: string) {
    this.translate.use(lang);
  }
}
